import { type BookChapter } from './book';
import { detectChapterHeading } from './pdf';

/**
 * Plain text → chapters. Paragraphs are blank-line separated and kept verbatim (no stripping — txt
 * is already raw). A "Chapter N" / "Part N" style line starts a new chapter; everything before the
 * first such line goes under `fallbackLabel` (the book title).
 */
export function parsePlainText(text: string, fallbackLabel: string): BookChapter[] {
  const blocks = text
    .split(/\r?\n\s*\r?\n/)
    .map((b) => b.replace(/\s+/g, ' ').trim())
    .filter((b) => b.length > 0);

  const chapters: BookChapter[] = [];
  let current: BookChapter | null = null;
  let index = 0;

  for (const block of blocks) {
    const heading = detectChapterHeading(block);
    if (heading) {
      current = { href: `txt-${index++}`, label: heading, paragraphs: [] };
      chapters.push(current);
    } else {
      if (!current) {
        current = { href: `txt-${index++}`, label: fallbackLabel, paragraphs: [] };
        chapters.push(current);
      }
      current.paragraphs.push(block);
    }
  }
  return chapters.filter((c) => c.paragraphs.length > 0);
}
